/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipAltReportExportStatusQueryResponse, GetGipAltReportExportStatusPathParams, GetGipAltReportExportStatus404 } from "../models/GetGipAltReportExportStatus";

export function getGetGipAltReportExportStatusUrl(id: GetGipAltReportExportStatusPathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip-alt/report/${id}/export-status` as const }
  return res
}

/**
 * @summary Get export job status for report
 * {@link /reports/gip-alt/report/:id/export-status}
 */
export async function getGipAltReportExportStatus(id: GetGipAltReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetGipAltReportExportStatusQueryResponse, ResponseErrorConfig<GetGipAltReportExportStatus404>, unknown>({ method : "GET", url : getGetGipAltReportExportStatusUrl(id).url.toString(), ... requestConfig })
  return res.data
}